import _ from 'lodash';
import { localStorage } from '@fiverr-private/futile';
import { sendBigQueryEvents } from '../sendEvents';
import {
    DISPATCH_DELAY,
    STORAGE_KEY
} from '../constants';

/**
 * Empty events from localStorage and send them
 * no return value
 */
function dispatch() {
    const events = localStorage.get(STORAGE_KEY);

    if (!events) {
        return;
    }

    sendBigQueryEvents(events);

    localStorage.set(STORAGE_KEY, []);
}

try {

    /**
     * Throttled run of dispatch
     * @type {Function}
     */
    dispatch.throttled = _.throttle(dispatch, DISPATCH_DELAY, { leading: false });

    // Report any pre stored events on load

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', dispatch, { once: true });
    } else { // interactive, complete
        dispatch();
    }

    window.addEventListener('beforeunload', dispatch, { once: true });
} catch (error) {

    // Fail silently (probably non browser environment)
}

export { dispatch };
